/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { ChangeDetectionStrategy, Component, HostListener, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-delete-confirm-dialog',
  templateUrl: './delete-confirm-dialog.component.html',
  styleUrls: ['./delete-confirm-dialog.component.scss']
})
export class DeleteConfirmDialogComponent {

  @Input() public text = 'Are you you want to delete it?';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { text: string, title: string },
    private mdDialogRef: MatDialogRef<DeleteConfirmDialogComponent>,
  ) { }

  public cancel() {
    this.close();
  }

  public close(isOk: boolean = false) {
    this.mdDialogRef.close(isOk);
  }

  public delete() {
    this.close(true);
  }

  @HostListener('keydown.esc')
  public onEsc() {
    this.close();
  }

}
